import { useLoaderData, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import ModeBar, { ModeBarIcon } from 'components/ModeBar';
import { trackEvent } from 'lib/amplitude';

const Page = styled.div`
  display: flex;
  flex-grow: 1;
`;

const Wrapper = styled.section`
  width: 100vw;
  padding: 120px 24px;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  background-color: #f5f7fb;
`;

const Callout = styled.div`
  background-color: #e9eff9;
  margin: auto;
  width: 560px;
  padding: 12px 24px 16px;
  border-radius: 22px;
`;

const Header = styled.h1`
  color: #18224f;
  font-weight: 500;

  &::after {
    width: 100%;
    height: 1px;
    content: '';
    display: block;
    color: #cad5e7;
    background-color: #cad5e7;
    margin-top: 0.83em;
  }
`;

const Link = styled.a`
  color: #4a75ce;
  text-decoration: none;
  font-weight: 500;
`;

const Text = styled.p`
  color: #414b78;
  opacity: 0.94;
  font-weight: 500;
  line-height: 1.4;
`;

/**
 * The component to display when a dashboard is not found
 *
 * @returns {JSX.Element} - the not found component
 */
export default function Project() {
  const { orgKey, projectKey } = useParams();
  const { organization, projectType } = useLoaderData();
  const exploreURL = `${import.meta.env.UF_APP_ORIGIN}/explore/${orgKey}/project/${projectKey}`;
  return (
    <Page>
      <ModeBar
        hasProject={!!projectKey}
        onClickMap={(e) => {
          e.preventDefault();
          trackEvent('No Dashboards - Return to Analyst', {
            orgKey,
            projectKey,
          });
          window.location.assign(exploreURL);
        }}
        styles={projectType.style}
      >
        <ModeBarIcon
          src={projectType.icon_url}
          label={projectType.key}
          onClick={(e) => {
            e.preventDefault();
            trackEvent('No Dashboards - Return to Analyst', {
              orgKey,
              projectKey,
            });
            window.location.assign(`${exploreURL}?maponly=1`);
          }}
        />
      </ModeBar>
      <Wrapper>
        <Callout>
          <Header>No dashboards in project</Header>
          <Text>
            There are no dashboards in the project you selected. Please select a
            dashboard from the menu, or learn how to{' '}
            <Link
              href={`${organization.help_url}/en/index-en.html?contextId=usecases`}
            >
              create a dashboard
            </Link>
            .
          </Text>
        </Callout>
      </Wrapper>
    </Page>
  );
}
